export default {
  addBanking: {
    method: 'post',
    url: '/company/branch/create-banking'
  },
  updateBanking: {
    method: 'post',
    url: '/company/branch/update-banking'
  },
  deleteBanking: {
    method: 'delete',
    url: '/company/branch/delete-banking'
  },
  updateInvoice: {
    method: 'post',
    url: '/company/branch/update-invoice'
  }
}
